import { render, staticRenderFns } from "./OfficialMedia.vue?vue&type=template&id=42e48d38&scoped=true&"
import script from "./OfficialMedia.vue?vue&type=script&lang=js&"
export * from "./OfficialMedia.vue?vue&type=script&lang=js&"
import style0 from "./OfficialMedia.vue?vue&type=style&index=0&id=42e48d38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e48d38",
  null
  
)

export default component.exports